import BarChart from "@rio-cloud/rio-uikit/BarChart";
import Bar from "@rio-cloud/rio-uikit/Bar";
import Tooltip from "@rio-cloud/rio-uikit/Tooltip";
import OverlayTrigger from "@rio-cloud/rio-uikit/OverlayTrigger";

type CustomData = {
  label: string;
  color: string;
  value: number;
};

interface VerticalBarChartProps {
  title: string;
  data: CustomData[];
  yAxisWidth?: number;
  marginRight?: number;
  onBarClick?: (value: { label: string; value: number }) => void;
  formatValue?: (value: number) => string;
}

const VerticalBarChart = ({
  title,
  data,
  yAxisWidth,
  marginRight,
  onBarClick,
  formatValue,
}: VerticalBarChartProps) => {
  const sanitizedData = data.map((item) => ({
    ...item,
    label: item.label?.trim() || "-",
  }));

  const barHeight = 40;
  const chartHeight = sanitizedData.length * barHeight;

  return (
    <div className="panel panel-default dark:bg-gray-700 panel-body margin-bottom-0 min-h-[360px] h-full overflow-y-auto">
      <p className="border-b pb-[12px] mb-[12px] text-center font-semibold text-2xl mt-2 dark:text-white">{title}</p>
      <div
        style={{ height: chartHeight }}
        className="vertical-bar-chart-container"
      >
        <BarChart
          data={sanitizedData}
          tooltip={false}
          layout="vertical"
          useDataColors
          margin={{ right: marginRight || 40 }}
          barCategoryGap="10%"
          xAxisOptions={{
            dataKey: "value",
            type: "number",
            height: 0,
            axisLine: false,
            tickLine: false,
            fontStyle: "normal",
          }}
          yAxisOptions={{
            dataKey: "label",
            type: "category",
            width: yAxisWidth || 90,
            tickLine: false,
            axisLine: false,
            tickMargin: 8,
            fontStyle: "normal",
            tick: ({ x, y, payload, index }) => {
              const fullText = payload.value?.trim() || "-";
              const truncatedText =
                fullText.length > 10 ? fullText.slice(0, 10) + "…" : fullText;

              return (
                <OverlayTrigger
                  key={`tooltip-${index}`}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-${index}`} allowOnTouch>
                      {fullText}
                    </Tooltip>
                  }
                >
                  <text
                    x={60}
                    y={y}
                    dy={4}
                    textAnchor="middle"
                    className="y-axis-label"
                  >
                    {truncatedText}
                  </text>
                </OverlayTrigger>
              );
            },
          }}
          bars={[
            <Bar
              key="value"
              dataKey="value"
              label={{
                position: "right",
                fill: "#666666",
                width: 100,
                fontSize: 14,
                formatter: (value: number) =>
                  formatValue ? formatValue(value) : `${value}`,
              }}
              onClick={onBarClick}
              barSize={30}
            />,
          ]}
        />
      </div>
    </div>
  );
};

export default VerticalBarChart;
